<template>
  <form-field
    :name="field.name"
    :hide="field.hide"
    :section="field.section"
  >
    <v-select
      v-model="field.value"
      v-bind="field.props"
      :menu-props="{ maxHeight: 'auto' }"
      box
    >
      <!-- Generic item slot that respects field.props['item-text'] and optional subtitle key -->
      <template
        v-if="useCustomItem"
        slot="item"
        slot-scope="data"
      >
        <v-list-tile-avatar v-if="hasAvatar">
          <v-icon>{{ data.item.avatar }}</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title v-html="getItemText(data.item)" />
          <v-list-tile-sub-title
            v-if="getItemSubtitle(data.item)"
            v-html="getItemSubtitle(data.item)"
          />
        </v-list-tile-content>
      </template>
    </v-select>
  </form-field>
</template>

<script>
import formField from '@/mixins/form-field'

export default {
  mixins: [formField],
  computed: {
    // whether it's safe to inspect items
    itemsSafe () {
      return Array.isArray(this.field && this.field.props && this.field.props.items) && this.field.props.items.length > 0
    },
    // detect avatar presence safely
    hasAvatar () {
      if (!this.itemsSafe) return false
      return this.field.props.items.some(item => !!item.avatar)
    },
    // whether to render custom item slot: only when items exist
    useCustomItem () {
      return this.itemsSafe
    },
    // keys to use for title/subtitle
    itemTextKey () {
      // support both kebab and camel case props
      return this.field && this.field.props && (this.field.props['item-text'] || this.field.props.itemText || 'text')
    },
    itemSubtitleKey () {
      // try common subtitle props: 'description', 'subtitle', 'item-subtitle'
      const p = this.field && this.field.props && this.field.props
      return p && (p['item-subtitle'] || p.itemSubtitle || p.description || 'description')
    },
  },
  methods: {
    // safely get title text
    getItemText (item) {
      if (!item) return ''
      const key = this.itemTextKey
      // if item is primitive (string/number) return it directly
      if (typeof item === 'string' || typeof item === 'number') return item
      // else try the configured key, then fallback: name, code, title
      return (item[key] !== undefined && item[key] !== null) ? item[key]
        : (item.name || item.code || item.title || '')
    },
    // safely get subtitle text
    getItemSubtitle (item) {
      if (!item) return ''
      const key = this.itemSubtitleKey
      if (typeof item === 'string' || typeof item === 'number') return ''
      return (item[key] !== undefined && item[key] !== null) ? item[key]
        : (item.description || item.subtitle || '')
    },
  },
}
</script>
